export const OPEN_EDIT_SECTION_POPUP = 'OPEN_EDIT_SECTION_POPUP';
export const ADD_IMAGES_IN_THE_SECTION_EDIT_POPUP =
    'ADD_IMAGES_IN_THE_SECTION_EDIT_POPUP';
export const ADD_IMAGE_IN_THE_SECTION_EDIT_POPUP =
    'ADD_IMAGE_IN_THE_SECTION_EDIT_POPUP';
export const ADD_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'ADD_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const ADD_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'ADD_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const ADD_IMAGE_IN_VALUE_PROPOSITION_POPUP =
    'ADD_IMAGE_IN_VALUE_PROPOSITION_POPUP';
export const ADD_SECTION_SECTION_SETTING_IN_THE_SECTION_EDIT_POPUP =
    'ADD_SECTION_SECTION_SETTING_IN_THE_SECTION_EDIT_POPUP';
export const ADD_SECTION_IMAGE_SETTING_IN_THE_SECTION_EDIT_POPUP =
    'ADD_SECTION_IMAGE_SETTING_IN_THE_SECTION_EDIT_POPUP';
export const ADD_SECTION_VIDEO_SETTING_IN_THE_SECTION_EDIT_POPUP =
    'ADD_SECTION_VIDEO_SETTING_IN_THE_SECTION_EDIT_POPUP';
export const REMOVE_IMAGE_FROM_THE_SECTION_EDIT_POPUP =
    'REMOVE_IMAGE_FROM_THE_SECTION_EDIT_POPUP';
export const REMOVE_SINGLE_IMAGE_FROM_THE_SECTION_EDIT_POPUP =
    'REMOVE_SINGLE_IMAGE_FROM_THE_SECTION_EDIT_POPUP';
export const REMOVE_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'REMOVE_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const REMOVE_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'REMOVE_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const REMOVE_IMAGE_IN_VALUE_PROPOSITION_POPUP =
    'REMOVE_IMAGE_IN_VALUE_PROPOSITION_POPUP';
export const UPDATE_BODY_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_BODY_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_SINGLE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_SINGLE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_INSTRUCTIONS_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_INSTRUCTIONS_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_TITLE_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_TITLE_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_SINGLE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_SINGLE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_THUMB_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'UPDATE_THUMB_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const UPDATE_THUMB_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'UPDATE_THUMB_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const UPDATE_THUMB_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP =
    'UPDATE_THUMB_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP';
export const UPDATE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_SINGLE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_SINGLE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP =
    'UPDATE_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP';
export const UPDATE_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'UPDATE_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const UPDATE_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP =
    'UPDATE_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP';
export const UPDATE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_SINGLE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_SINGLE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_SINGLE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_SINGLE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_IMAGE_META_IN_VALUE_PROPOSITION_POPUP =
    'UPDATE_IMAGE_META_IN_VALUE_PROPOSITION_POPUP';
export const UPDATE_SNIPPET_IMAGE_META_IN_LARGE_SNIPPETS_POPUP =
    'UPDATE_SNIPPET_IMAGE_META_IN_LARGE_SNIPPETS_POPUP';
export const UPDATE_LOGO_IMAGE_META_IN_LARGE_SNIPPETS_POPUP =
    'UPDATE_LOGO_IMAGE_META_IN_LARGE_SNIPPETS_POPUP';
export const UPDATE_IMAGE_SORT_ORDER_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_IMAGE_SORT_ORDER_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_MAP_SECTION_LOCATION_DESCRIPTION_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_MAP_SECTION_LOCATION_DESCRIPTION_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_NOT_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_NOT_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP';
export const ADD_DOCUMENTS_IN_THE_SECTION_EDIT_POPUP =
    'ADD_DOCUMENTS_IN_THE_SECTION_EDIT_POPUP';
export const REMOVE_DOCUMENT_FROM_THE_SECTION_EDIT_POPUP =
    'REMOVE_DOCUMENT_FROM_THE_SECTION_EDIT_POPUP';
export const ADD_REVIEWS_TO_SITE = 'ADD_REVIEWS_TO_SITE';
export const REMOVE_REVIEWS_FOR_SITE = 'REMOVE_REVIEWS_FOR_SITE';
export const SORT_SELECTED_REVIEWS_IN_THE_SECTION_EDIT_POPUP =
    'SORT_SELECTED_REVIEWS_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_FORM_TYPE_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_FORM_TYPE_IN_THE_SECTION_EDIT_POPUP';
export const ADD_FAQS_TO_SITE = 'ADD_FAQS_TO_SITE';
export const REMOVE_FAQS_FOR_SITE = 'REMOVE_FAQS_FOR_SITE';
export const SORT_SELECTED_FAQS_IN_THE_SECTION_EDIT_POPUP =
    'SORT_SELECTED_FAQS_IN_THE_SECTION_EDIT_POPUP';
export const SELECT_FIND_YOUR_PROJECT_DESTINATIONS =
    'SELECT_FIND_YOUR_PROJECT_DESTINATIONS';
export const SELECT_FIND_YOUR_PROJECT_PROJECTS =
    'SELECT_FIND_YOUR_PROJECT_PROJECTS';
export const UPDATE_MEETINGS_BODY_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_MEETINGS_BODY_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_CAREERS_BODY_IN_THE_SECTION_EDIT_POPUP =
    'UPDATE_CAREERS_BODY_IN_THE_SECTION_EDIT_POPUP';
export const UPDATE_GROUP_TRIPS_BANNER_SECTION_SUBHEADING_FIELD =
    'UPDATE_GROUP_TRIPS_BANNER_SECTION_SUBHEADING_FIELD';
export const PICK_SECTION_PAGE = 'PICK_SECTION_PAGE';
export const PICK_LARGE_SNIPPET_PAGE = 'PICK_LARGE_SNIPPET_PAGE';
export const PICK_VALUE_PROPOSITION_PAGE = 'PICK_VALUE_PROPOSITION_PAGE';
export const PICK_VALUE_PROPOSITION_BUTTON_TEXT =
    'PICK_VALUE_PROPOSITION_BUTTON_TEXT';
export const UPDATE_VALUE_PROPOSITION_TITLE = 'UPDATE_VALUE_PROPOSITION_TITLE';
export const UPDATE_VALUE_PROPOSITION_BODY = 'UPDATE_VALUE_PROPOSITION_BODY';
export const UPDATE_MEET_US_EVENTS_PAGE = 'UPDATE_MEET_US_EVENTS_PAGE';
export const UPDATE_MEET_US_MEETINGS_PAGE = 'UPDATE_MEET_US_MEETINGS_PAGE';
export const UPDATE_MEET_US_CAREERS_PAGE = 'UPDATE_MEET_US_CAREERS_PAGE';



// WEBPACK FOOTER //
// ./src/containers/builder/sections/types.js